import React from 'react';
import { connect } from 'react-redux';
import { Grid, Paper, Typography, withStyles, Button } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { BackButton } from '../sc-utilities';
import { icon } from '../sc-download-page/Mobile';
import { styles } from './index';

const MobileManual = (props) => {
    const { classes, translations } = props;

    return (
        <Paper className={classes.root}>
            <div className={classes.customToolbar}>
                <div className={classes.tableTitle}>
                    {BackButton(translations, classes.customTooltip)}
                    <Typography className={classes.typography}>
                        {translations['user_manuals'] || 'User Manuals'}
                    </Typography>
                </div>
            </div>

            <Grid container direction="row" className={classes.grid}>
                <Grid item ms={12} lg={6}>
                    <h2>
                        {icon} Mobile{' '}
                        {classes.latestVersionSpan && (
                            <span className={classes.latestVersionSpan}>
                                - {translations['latest_version'] || 'Latest Version'}
                            </span>
                        )}
                    </h2>
                    <p>
                        {translations['mobile_download_page'] ||
                            'Complete tool for secure erasure & diagnostics of smartphones and tablets (iOS & Android).'}
                    </p>
                </Grid>
                <Grid container xs={12} sm={6}>
                    <Grid item xs={12} sm={6}>
                        <a
                            href="https://securaze.com/en/help/mobile"
                            download
                            target={'_blank'}
                            rel="noopener noreferrer"
                            className={classes.link}
                        >
                            <Button color={'primary'} variant={'contained'} className={classes.history}>
                                <GetAppIcon /> {translations['mobile_windows'] || 'Mobile Windows'}
                                {'.pdf'}
                            </Button>
                        </a>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <a
                            href="https://securaze.com/en/help/mobilelinux"
                            download
                            target={'_blank'}
                            rel="noopener noreferrer"
                            className={classes.link}
                        >
                            <Button color={'primary'} variant={'contained'} className={classes.history}>
                                <GetAppIcon /> {translations['mobile_linux'] || 'Mobile Linux'}
                                {'.pdf'}
                            </Button>
                        </a>
                    </Grid>
                </Grid>
                <Grid
                    item
                    ms={12}
                    lg={12}
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="baseline"
                    style={{ marginTop: '1rem' }}
                >
                    <Grid item xl={6}>
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/nUSYmtneBDs?si=BzOp7Aia9x0QhRtg"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                        ></iframe>
                    </Grid>
                    <Grid item xl={6}>
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/Vx_yKiRI6zM?si=puHWT9gYrC3Je699"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                        ></iframe>
                    </Grid>
                </Grid>
                <Grid
                    item
                    ms={12}
                    lg={12}
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="baseline"
                    style={{ marginTop: '1rem' }}
                >
                    <Grid item xl={6}>
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/GUO0lNaaq18?si=qdpxvNFk-hICNlMM"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                        ></iframe>
                    </Grid>
                    <Grid item xl={6}>
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/0r3OlxZ64Sk?si=bNLch0kjJ46y5XCF"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                        ></iframe>
                    </Grid>
                </Grid>
                <Grid
                    item
                    ms={12}
                    lg={12}
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="baseline"
                    style={{ marginTop: '1rem' }}
                >
                    <Grid item xl={6}>
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/_s8STNo9yzg?si=gHzlx-e_qPoWoVD_"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                        ></iframe>
                    </Grid>
                    <Grid item xl={6}>
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/JT0hziIURfg?si=6U_O0wyfOAXMyDFm"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                        ></iframe>
                    </Grid>
                </Grid>
                <Grid
                    item
                    ms={12}
                    lg={12}
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="baseline"
                    style={{ marginTop: '1rem' }}
                >
                    <Grid item xl={6}>
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/BGJCxS3Waz0?si=0LTM89rhgzxrqsl3"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                        ></iframe>
                    </Grid>
                    <Grid item xl={6}>
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/EdBAFmcEWyM?si=nNpSgopL-QFDG88-"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                        ></iframe>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = (state) => {
    return {
        translations: state?.translate?.translations?.activeTranslations || {},
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(MobileManual));
